export const products = {
    //Live products
    "tv": [
        // {
        //     id: "prod_Nn2s0R15jQje27",
        //     name: "TripValet Annual",
        //     price: "price_1N1SmqDfGKjcFXEHBXw6bOX0"
        // },
        // {
        //     id: "prod_Nn2qbv5yEEQTMv",
        //     name: "TripValet Monthly",
        //     price: "price_1N1SlIDfGKjcFXEH9KvWhWmR"
        // }
        {
            id: "prod_UNMJ11RA403veA",
            name: "TripValet Annual",
            price: "price_1TObalIB7ByDDUZGauYOsldL"
        },
        {
            id: "prod_UNMG8oNHszHQa2",
            name: "TripValet Monthly",
            price: "price_1TObXlIB7ByDDUZGhPDQUEAR"
        }
    ]

    // live products
    // "tv" :  [
    //     {
    //         id:"prod_NQfXs224JhSmWK",
    //         name: "TripValet Annual",
    //         price:"price_1MfoCrDfGKjcFXEHZi6bxGBI"
    //     },
    //     {
    //         id:"prod_NQfbaNCqLLRAJs",
    //         name: "TripValet Monthly",
    //         price:"price_1MfoGXDfGKjcFXEHLlVWcfDK"
    //     }
    // ]
}

